<template>
    <div class="OOP-today">
        <div class="player-filter__type player-filter__type--full">
            <select ref="courtSelector" id="courtSelector" name="courtSelector" v-model="selectedCourt">
                <option v-for="(court, courtIndex) in courts" :value="court">{{court}}</option>
            </select>
        </div>

        <div class="OOP-today__matches">
            <oop-match v-for="match in matches"
                       :key="match.id"
                       :wta="wtaMatches"
                       :flagPath="flagPath"
                       type="all"
                       :match="match"
                       :detail="detail">
            </oop-match>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import OOPMatch from './OOPMatch'
    import 'select2/dist/js/select2.full.js'
    import tz from 'moment-timezone'

    export default {
        props: ['tournament', 'flag', 'detail'],
        components: {
            'oop-match': OOPMatch
        },
        data() {
            return {
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                oop             : [],
                today           : '',
                wtaMatches      : [],
                selectedCourt   : '',
                matches         : [],
                courts          : [],
                tournament_slug : this.tournament,
            }
        },
        mounted() {
            let app = this
            jQuery('#courtSelector').select2({
                width: '100%'
            }).on('change', function () {
                app.selectedCourt = this.value
            })
        },
        watch: {
            selectedCourt(newValue, oldValue) {
                let matches = this.getMatchesByCourt(newValue)

                this.matches = matches.filter( function( match ) {
                    if ( match.type == this.type )
                        return true
                })
            }
        },
        created() {
            this.getFeed()
        },
        methods: {
            getFeed() {
                axios.get(`${window.feed_ip}/get/${this.type}/${this.tournament_slug}/oop`).then(response => {

                    let oop = response.data

                    let today = oop.filter(function (day) {
                        let todayDate = moment().tz('Asia/Dubai').startOf('day').format('YYYY-MM-DD')
                        return day.date == todayDate
                    })

                    this.oop = response.data

                    if (today.length == '0') {

                        let totalDaysCount = response.data.length
                        this.today = response.data[totalDaysCount - 1]
                        this.selectedCourt = response.data[totalDaysCount - 1].courts[0].name

                    } else {

                        this.today = today[0]
                        this.selectedCourt = today[0].courts[0].name

                    }

                    let matches = this.getMatchesByCourt(this.selectedCourt)

                    this.matches = matches.filter( function( match ) {
                        if ( match.type == this.type )
                            return true
                    })

                    this.setupCourts()

                }).catch(function (error) {
                    console.log(error);
                });
            },
            setupCourts() {
                let courts = []

                for ( let court of this.today.courts )
                    courts.push(court.name)

                this.courts = courts

            },
            getMatchesByCourt(name) {
                let foundCourt = this.today.courts.filter(function (court) {
                    return court.name == name
                })

                return foundCourt[0].matches
            }
        }
    }
</script>
